import { useContext, useEffect, FunctionComponent } from 'react';
import * as React from 'react';
import { Bar } from '../Bar';
import { Header } from '../Header';
import classnames from 'classnames';
import { ModalContext } from '../ModalContainer/modalContext';
import { HeadingType } from 'dibs-controlled-heading/exports/HeadingLevel';

import styles from './main.scss';

type BarHeaderProps = {
    size?: 'small' | 'medium' | 'large' | 'xLarge' | 'xxLarge';
    dataTn?: string;
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    htmlElementType?: 'div' | 'h1' | 'h2' | HeadingType;
    type?: 'trade' | 'default';
    id?: string;
};

export const BarHeader: FunctionComponent<BarHeaderProps> = ({
    size = 'large',
    title,
    subtitle,
    dataTn,
    htmlElementType = 'div',
    type = 'default',
}) => {
    const { labelUid, setLabelActive } = useContext(ModalContext);
    useEffect(() => {
        // ensure UID is active on render
        setLabelActive(true);
        // deactivate UID on unmount
        return () => setLabelActive(false);
    }, [setLabelActive]);
    return (
        <div
            className={classnames(styles.headerWrapper, styles[size])}
            data-tn={`bar-header${dataTn ? `-${dataTn}` : ''}`}
        >
            <Header
                id={labelUid || undefined}
                title={title}
                subtitle={subtitle}
                htmlElementType={htmlElementType}
                size={size}
                dataTn={dataTn}
            />
            <Bar size={size} type={type} />
        </div>
    );
};
